'use strict';

/**
 * The consumer onboarding steps: each `completed` token and the Register page that writes
 * it. Register maps them to pick a returning user's step; Dashboard checks them to decide
 * whether to send the user back there.
 *
 * Not the backend's rule - ProfileCompletionTrait asks whether we can generate meal
 * content, and needs fewer parts.
 */
export const ONBOARDING_PART_PAGES = {
    conditions: 'Conditions',
    anthro: 'Biometrics',
    nutrition: 'Energy',
    energy: 'Energy',
    mealDetails: 'Meal Details',
    taste: 'Avoidances',
    family: 'Family',
    meals: 'Preferences',
};

export const ONBOARDING_PARTS = Object.keys(ONBOARDING_PART_PAGES);

export function hasFinishedOnboarding(completed = []) {
    return ONBOARDING_PARTS.every(part => completed.includes(part));
}

export function missingOnboardingParts(completed = []) {
    return ONBOARDING_PARTS.filter(part => !completed.includes(part));
}
